export function shouldAdoptCurrentMediaOnPlaylistOpen({
    source = null,
    focusMediaKey = null,
    hasFocusedTrack = false,
    nowPlayingMediaKey = null,
    isPlaying = false,
    takeoverKey = null,
} = {}) {
    return Boolean(
        source === 'filter_options' &&
            focusMediaKey &&
            hasFocusedTrack &&
            nowPlayingMediaKey === focusMediaKey &&
            isPlaying &&
            takeoverKey !== focusMediaKey,
    )
}
